import img0 from '../assets/img/carousel/acto_de_grado_0.jpg';
import img1 from '../assets/img/carousel/acto_de_grado_1.jpg';
import img2 from '../assets/img/carousel/acto_de_grado_2.jpg';
import img3 from '../assets/img/carousel/acto_de_grado_3.jpg';
import img4 from '../assets/img/carousel/acto_de_grado_4.jpg';
import img5 from '../assets/img/carousel/acto_de_grado_5.jpg';
import img6 from '../assets/img/carousel/acto_de_grado_6.jpg';
import img7 from '../assets/img/carousel/acto_de_grado_7.jpg';
import img8 from '../assets/img/carousel/acto_de_grado_8.jpg';
import img9 from '../assets/img/carousel/acto_de_grado_9.jpg';

const SlideItems = [
    {
        id: 1,
        img: img0
    },
    {
        id: 2,
        img: img1
    },
    {
        id: 3,
        img: img2
    },
    {
        id: 4,
        img: img3
    },
    {
        id: 5,
        img: img4
    },
    {
        id: 6,
        img: img5
    },
    {
        id: 7,
        img: img6
    },
    {
        id: 8,
        img: img7
    },
    {
        id: 9,
        img: img8
    },
    {
        id: 10,
        img: img9
    },
]

export default SlideItems;


// WEBPACK FOOTER //
// ./src/shared/EventSlideItems.jsx